import polyglotI18nProvider from "ra-i18n-polyglot";
import i18next from "i18next";

const frenchMessages = {
  ra: {
    action: {
      add_filter: "Ajouter un filtre",
      add: "Ajouter",
      back: "Retour",
      bulk_actions:
        "1 élément sélectionné |||| %{smart_count} éléments sélectionnés",
      cancel: "Annuler",
      clear_input_value: "Effacer la valeur",
      clone: "Cloner",
      confirm: "Confirmer",
      create: "Créer",
      create_item: "Créer %{item}",
      delete: "Supprimer",
      edit: "Modifier",
      export: "Exporter",
      list: "Liste",
      refresh: "Actualiser",
      remove_filter: "Retirer ce filtre",
      remove: "Retirer",
      save: "Enregistrer",
      search: "Rechercher",
      select_all: "Tout sélectionner",
      select_row: "Sélectionner cette ligne",
      show: "Afficher",
      sort: "Trier",
      undo: "Annuler",
      unselect: "Désélectionner",
      expand: "Développer",
      close: "Fermer",
      open_menu: "Ouvrir le menu",
      close_menu: "Fermer le menu",
      update: "Mettre à jour",
      move_up: "Monter",
      move_down: "Descendre",
      open: "Ouvrir",
      toggle_theme: "Changer le thème",
    },
    boolean: {
      true: "Oui",
      false: "Non",
      null: "\u2003",
    },
    page: {
      create: "Créer %{name}",
      dashboard: "Tableau de bord",
      edit: "%{name} #%{id}",
      error: "Une erreur est survenue",
      list: "%{name}",
      loading: "Chargement",
      not_found: "Introuvable",
      show: "%{name} #%{id}",
      empty: "Pas encore de %{name}.",
      invite: "Voulez-vous en ajouter un ?",
    },
    input: {
      file: {
        upload_several:
          "Déposez des fichiers pour les télécharger, ou cliquez pour en sélectionner un.",
        upload_single:
          "Déposez un fichier pour le télécharger, ou cliquez pour en sélectionner un.",
      },
      image: {
        upload_several:
          "Déposez des images pour les télécharger, ou cliquez pour en sélectionner une.",
        upload_single:
          "Déposez une image pour la télécharger, ou cliquez pour en sélectionner une.",
      },
      references: {
        all_missing: "Impossible de trouver les données de référence.",
        many_missing:
          "Au moins une des références associées ne semble plus disponible.",
        single_missing: "La référence associée ne semble plus disponible.",
      },
      password: {
        toggle_visible: "Masquer le mot de passe",
        toggle_hidden: "Afficher le mot de passe",
      },
    },
    message: {
      about: "À propos",
      are_you_sure: "Êtes-vous sûr ?",
      bulk_delete_content:
        "Êtes-vous sûr de vouloir supprimer ce %{name} ? |||| Êtes-vous sûr de vouloir supprimer ces %{smart_count} éléments ?",
      bulk_delete_title:
        "Supprimer %{name} |||| Supprimer %{smart_count} %{name}",
      bulk_update_content:
        "Êtes-vous sûr de vouloir mettre à jour ce %{name} ? |||| Êtes-vous sûr de vouloir mettre à jour ces %{smart_count} éléments ?",
      bulk_update_title:
        "Mettre à jour %{name} |||| Mettre à jour %{smart_count} %{name}",
      delete_content: "Êtes-vous sûr de vouloir supprimer cet élément ?",
      delete_title: "Supprimer %{name} #%{id}",
      details: "Détails",
      error:
        "Une erreur client s'est produite et votre requête n'a pas pu être terminée.",
      invalid_form:
        "Le formulaire n'est pas valide. Veuillez vérifier les erreurs",
      loading: "La page est en cours de chargement, veuillez patienter",
      no: "Non",
      not_found:
        "Vous avez soit saisi une mauvaise URL, soit suivi un lien incorrect.",
      yes: "Oui",
      unsaved_changes:
        "Certaines de vos modifications n'ont pas été enregistrées. Êtes-vous sûr de vouloir les ignorer ?",
    },
    navigation: {
      no_results: "Aucun résultat trouvé",
      no_more_results:
        "La page numéro %{page} est hors limites. Essayez la page précédente.",
      page_out_of_boundaries: "La page numéro %{page} est hors limites",
      page_out_from_end: "Impossible d'aller après la dernière page",
      page_out_from_begin: "Impossible d'aller avant la page 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} sur %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} sur plus de %{offsetEnd}",
      current_page: "Page %{page}",
      page: "Aller à la page %{page}",
      first: "Aller à la première page",
      last: "Aller à la dernière page",
      next: "Aller à la page suivante",
      previous: "Aller à la page précédente",
      page_rows_per_page: "Lignes par page :",
      skip_nav: "Aller au contenu",
    },
    sort: {
      sort_by: "Trier par %{field} %{order}",
      ASC: "croissant",
      DESC: "décroissant",
    },
    auth: {
      auth_check_error: "Veuillez vous connecter pour continuer",
      user_menu: "Profil",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      sign_in: "Connexion",
      sign_in_error: "L'authentification a échoué, veuillez réessayer",
      logout: "Déconnexion",
    },
    notification: {
      updated:
        "Élément mis à jour |||| %{smart_count} éléments mis à jour",
      created: "Élément créé",
      deleted:
        "Élément supprimé |||| %{smart_count} éléments supprimés",
      bad_item: "Élément incorrect",
      item_doesnt_exist: "L'élément n'existe pas",
      http_error: "Erreur de communication avec le serveur",
      data_provider_error:
        "Erreur du fournisseur de données. Consultez la console pour plus de détails.",
      i18n_error:
        "Impossible de charger les traductions pour la langue spécifiée",
      canceled: "Action annulée",
      logged_out:
        "Votre session est terminée, veuillez vous reconnecter.",
      not_authorized:
        "Vous n'êtes pas autorisé à accéder à cette ressource.",
    },
    validation: {
      required: "Requis",
      minLength: "Doit comporter au moins %{min} caractères",
      maxLength: "Doit comporter %{max} caractères ou moins",
      minValue: "Doit être au moins %{min}",
      maxValue: "Doit être %{max} ou moins",
      number: "Doit être un nombre",
      email: "Doit être un e-mail valide",
      oneOf: "Doit être l'un de : %{options}",
      regex: "Doit correspondre à un format spécifique (regexp) : %{pattern}",
    },
    saved_queries: {
      label: "Requêtes enregistrées",
      query_name: "Nom de la requête",
      new_label: "Enregistrer la requête actuelle...",
      new_dialog_title: "Enregistrer la requête actuelle sous",
      remove_label: "Supprimer la requête enregistrée",
      remove_label_with_name: 'Supprimer la requête "%{name}"',
      remove_dialog_title: "Supprimer la requête enregistrée ?",
      remove_message:
        "Êtes-vous sûr de vouloir retirer cet élément de votre liste de requêtes enregistrées ?",
      help: "Filtrez la liste et enregistrez cette requête pour plus tard",
    },
  },
};

const englishMessages = {
  ra: {
    action: {
      add_filter: "Add filter",
      add: "Add",
      back: "Go Back",
      bulk_actions:
        "1 item selected |||| %{smart_count} items selected",
      cancel: "Cancel",
      clear_input_value: "Clear value",
      clone: "Clone",
      confirm: "Confirm",
      create: "Create",
      create_item: "Create %{item}",
      delete: "Delete",
      edit: "Edit",
      export: "Export",
      list: "List",
      refresh: "Refresh",
      remove_filter: "Remove this filter",
      remove: "Remove",
      save: "Save",
      search: "Search",
      select_all: "Select all",
      select_row: "Select this row",
      show: "Show",
      sort: "Sort",
      undo: "Undo",
      unselect: "Unselect",
      expand: "Expand",
      close: "Close",
      open_menu: "Open menu",
      close_menu: "Close menu",
      update: "Update",
      move_up: "Move up",
      move_down: "Move down",
      open: "Open",
      toggle_theme: "Toggle Theme",
    },
    boolean: { true: "Yes", false: "No", null: "\u2003" },
    page: {
      create: "Create %{name}",
      dashboard: "Dashboard",
      edit: "%{name} #%{id}",
      error: "Something went wrong",
      list: "%{name}",
      loading: "Loading",
      not_found: "Not Found",
      show: "%{name} #%{id}",
      empty: "No %{name} yet.",
      invite: "Do you want to add one?",
    },
    input: {
      file: {
        upload_several:
          "Drop some files to upload, or click to select one.",
        upload_single:
          "Drop a file to upload, or click to select it.",
      },
      image: {
        upload_several:
          "Drop some pictures to upload, or click to select one.",
        upload_single:
          "Drop a picture to upload, or click to select it.",
      },
      references: {
        all_missing: "Unable to find references data.",
        many_missing:
          "At least one of the associated references no longer appears to be available.",
        single_missing:
          "Associated reference no longer appears to be available.",
      },
      password: {
        toggle_visible: "Hide password",
        toggle_hidden: "Show password",
      },
    },
    message: {
      about: "About",
      are_you_sure: "Are you sure?",
      bulk_delete_content:
        "Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?",
      bulk_delete_title:
        "Delete %{name} |||| Delete %{smart_count} %{name}",
      bulk_update_content:
        "Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?",
      bulk_update_title:
        "Update %{name} |||| Update %{smart_count} %{name}",
      delete_content: "Are you sure you want to delete this item?",
      delete_title: "Delete %{name} #%{id}",
      details: "Details",
      error:
        "A client error occurred and your request couldn't be completed.",
      invalid_form: "The form is not valid. Please check for errors",
      loading: "The page is loading, just a moment please",
      no: "No",
      not_found:
        "Either you typed a wrong URL, or you followed a bad link.",
      yes: "Yes",
      unsaved_changes:
        "Some of your changes weren't saved. Are you sure you want to ignore them?",
    },
    navigation: {
      no_results: "No results found",
      no_more_results:
        "The page number %{page} is out of boundaries. Try the previous page.",
      page_out_of_boundaries: "Page number %{page} out of boundaries",
      page_out_from_end: "Cannot go after last page",
      page_out_from_begin: "Cannot go before page 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} of %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}",
      current_page: "Page %{page}",
      page: "Go to page %{page}",
      first: "Go to first page",
      last: "Go to last page",
      next: "Go to next page",
      previous: "Go to previous page",
      page_rows_per_page: "Rows per page:",
      skip_nav: "Skip to content",
    },
    sort: {
      sort_by: "Sort by %{field} %{order}",
      ASC: "ascending",
      DESC: "descending",
    },
    auth: {
      auth_check_error: "Please login to continue",
      user_menu: "Profile",
      username: "Username",
      password: "Password",
      sign_in: "Sign in",
      sign_in_error: "Authentication failed, please retry",
      logout: "Logout",
    },
    notification: {
      updated:
        "Element updated |||| %{smart_count} elements updated",
      created: "Element created",
      deleted:
        "Element deleted |||| %{smart_count} elements deleted",
      bad_item: "Incorrect element",
      item_doesnt_exist: "Element does not exist",
      http_error: "Server communication error",
      data_provider_error:
        "dataProvider error. Check the console for details.",
      i18n_error:
        "Cannot load the translations for the specified language",
      canceled: "Action cancelled",
      logged_out:
        "Your session has ended, please reconnect.",
      not_authorized:
        "You're not authorized to access this resource.",
    },
    validation: {
      required: "Required",
      minLength: "Must be %{min} characters at least",
      maxLength: "Must be %{max} characters or less",
      minValue: "Must be at least %{min}",
      maxValue: "Must be %{max} or less",
      number: "Must be a number",
      email: "Must be a valid email",
      oneOf: "Must be one of: %{options}",
      regex: "Must match a specific format (regexp): %{pattern}",
    },
    saved_queries: {
      label: "Saved queries",
      query_name: "Query name",
      new_label: "Save current query...",
      new_dialog_title: "Save current query as",
      remove_label: "Remove saved query",
      remove_label_with_name: 'Remove query "%{name}"',
      remove_dialog_title: "Remove saved query?",
      remove_message:
        "Are you sure you want to remove that item from your list of saved queries?",
      help: "Filter the list and save this query for later",
    },
  },
};

const messages: Record<string, any> = {
  fr: frenchMessages,
  en: englishMessages,
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => messages[locale] || frenchMessages,
  localStorage.getItem("i18nextLng")?.startsWith("fr") ? "fr" : "fr"
);
